module.exports = __webpack_public_path__ + "media/application/images/icons/red-arrow-2e9cbf0902d2063cd6754ce6f481c155.svg";